// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + "6b306b10b9d0913f91b9e55b42ee17d3" + ".css";
};